import { render, staticRenderFns } from "./TabIntegrations.vue?vue&type=template&id=41953668&scoped=true"
import script from "./TabIntegrations.vue?vue&type=script&lang=js"
export * from "./TabIntegrations.vue?vue&type=script&lang=js"
import style0 from "./TabIntegrations.vue?vue&type=style&index=0&id=41953668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41953668",
  null
  
)

export default component.exports